import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import IP_URL from '../connect';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Redux/currentUserSlice';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Main = styled.div`
  background-color: #f7f9fc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Container = styled.div`
  margin: 20px;
  width: 95%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  padding: 15px;
  overflow-x: auto;

  @media (max-width: 768px) {
    margin: 10px;
    padding: 10px;
  }
`;

const Filters = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 15px;
  gap: 10px;

  button {
    padding: 8px 14px;
    border: none;
    border-radius: 6px;
    background-color: #0039a4;
    color: white;
    cursor: pointer;
    font-weight: 500;
    transition: background 0.3s ease;

    &:hover {
      background-color: #0055e0;
    }

    &.active {
      background-color: #00bcd4;
    }
  }
`;

const Table = styled.table`
  border-collapse: collapse;
  background-color: #fdfdfd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;

  th, td {
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    text-align: center;
    white-space: nowrap;
  }

  th {
    background-color: #1976d2;
    color: white;
    font-weight: bold;
  }

  tbody tr {
    transition: background 0.2s ease;
  }

  tbody tr:nth-child(odd) {
    background-color: #cce5f8ff;
  }

  tbody tr:hover {
    background-color: #e3f2fd;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    th, td {
      padding: 6px 8px;
    }
  }
`;

const Status = styled.td`
  color: ${({ status }) =>
    status === "sent" ? "green" :
    status === "pending" ? "orange" :
    "red"};
  font-weight: 600;
`;

const LoadingSpinner = styled.div`
  margin: 30px 0;
  font-size: 18px;
  color: #00bcd4;
`;

const Input = styled.input`
  padding: 8px;
  margin: 5px;
  border: 1px solid #ccc;
  border-radius: 6px;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  gap: 10px;

  button {
    padding: 6px 12px;
    border: none;
    border-radius: 6px;
    background-color: #0039a4;
    color: white;
    cursor: pointer;
    font-weight: 500;

    &:disabled {
      background-color: gray;
      cursor: not-allowed;
    }
  }

  span {
    font-weight: 600;
  }
`;
const FilterSelect = styled.select`
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #ffffff;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;

  &:hover {
    border-color: #00bcd4;
  }

  &:focus {
    border-color: #0039a4;
    box-shadow: 0 0 4px rgba(0, 57, 164, 0.4);
  }

  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 13px;
  }
`;


const CommandStatus = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { token } = useSelector(selectUser);
  const [loading, setLoading] = useState(false);
  const [commandData, setCommandData] = useState([]);
  const [imei, setImei] = useState('');
  const [date, setDate] = useState('');
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [limit] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  // Fetch commands
  useEffect(() => {
    const getCommands = async () => {
      setLoading(true);

      try {
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("limit", limit);
        if (imei) params.append("imei", imei);
        if (date) params.append("date", date);

        const url = `${IP_URL}/setCommands/all-commands?${params.toString()}`;
        const response = await fetch(url, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) throw new Error("Failed to fetch commands");

        const data = await response.json();
        setCommandData(data.data || []);
        setTotalPages(data.totalPages || 1);
        toast.success("Commands loaded successfully", { position: "bottom-right" });
      } catch (error) {
        console.error("Error fetching data", error);
        toast.error(error.message || "Something went wrong", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };

    getCommands();
  }, [imei, date, page, token, limit]);

  const filteredCommands = commandData.filter((cmd) => {
    if (filter === 'sent') return cmd.status === 'sent';
    if (filter === 'pending') return cmd.status === 'pending';
    return true;
  });

   const navigateToMeterDetails = (imei) => navigate(`/admin-meter-details/${imei}`);

  return (
    <Main>
      <Navbar showMenuButton={true} toggleSidebar={toggleSidebar} />
      <Content>
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <Container>
         

          {loading ? (
            <LoadingSpinner>Loading...</LoadingSpinner>
          ) : (
            <Table>
              <thead>
                <tr>
                  <th>  <Input
              type='text'
              placeholder='Search by IMEI'
              value={imei}
              onChange={(e) => setImei(e.target.value)}
            /></th>
                  <th></th>
                  <th></th>
              <th>
  <FilterSelect value={filter} onChange={(e) => setFilter(e.target.value)}>
    <option value="all">All</option>
    <option value="sent">Sent</option>
    <option value="pending">Pending</option>
  </FilterSelect>
</th>

                  <th> <Input
              type='date'
              value={date}
              onChange={(e) => setDate(e.target.value)}
            /></th>
                </tr>
                <tr>
                  <th>IMEI</th>
                  <th>Command</th>
                  <th>Parameters</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredCommands.length > 0 ? (
                  filteredCommands.map((cmd) => (
                    <tr key={cmd._id}>
                      <td onClick={() => navigateToMeterDetails(cmd.imei )}>{cmd.imei}</td>
                      <td>{cmd.command?.command}</td>
                      <td>{JSON.stringify(cmd.command?.params)}</td>
                      <Status status={cmd.status}>{cmd.status}</Status>
                      <td>{new Date(cmd.createdAt).toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No commands found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}

          <Pagination>
            <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Prev</button>
            <span>Page {page} of {totalPages}</span>
            <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)}>Next</button>
          </Pagination>
        </Container>
      </Content>

  
    </Main>
  );
};

export default CommandStatus;
